import { Col, Row } from 'react-bootstrap';
import CurrencyField from '../../../benefit/fields/CurrencyField';
import ReadOnlyCalculatedBenefits from '../cares/ReadOnlyCalculatedBenefits';

const EditablePpcBenefit = ({ incomeMeasurementType, incomeMeasurementPercentage, arrearage, energyDiscount, pledgeAmount, onPledgeAmountChange, isSubmitting }) => {

  return (
    <>
      <Row className="mt-3">
        <Col>
          <ReadOnlyCalculatedBenefits
            incomeMeasurementType={incomeMeasurementType}
            incomeMeasurementPercentage={incomeMeasurementPercentage}
            arrearage={arrearage}
            energyDiscount={energyDiscount}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={6}>
          <CurrencyField
            value={pledgeAmount}
            fieldName="Pledge Amount"
            onChange={onPledgeAmountChange}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditablePpcBenefit;